import * as ngCore from '@angular/core'

/**
 * Directive that enables drag and drop functionality for file uploads.
 * Emits the dropped files through the `filesDropped` output.
 */
@ngCore.Directive({
  host: {
    '(dragover)': '$event.preventDefault(); $event.stopPropagation();',
    '(drop)':
      '$event.preventDefault(); $event.stopPropagation(); onDrop($event)',
  },
  selector: '[fileDragAndDrop]',
})
export class Directive {
  /**
   * Emits the FileList when files are dropped onto the element.
   */
  public readonly filesDropped = ngCore.output<FileList>()

  /**
   * Handles the drop event and emits the dropped files.
   */
  protected onDrop(event: DragEvent): void {
    this.filesDropped.emit(event.dataTransfer?.files ?? new FileList())
  }
}
